import type { ServiceCategoryDto } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';
import { useMemo } from 'react';

const MAX = 3;

interface Props {
  categories: ReadonlyArray<ServiceCategoryDto>;
  value: string[];
  onChange: (next: string[]) => void;
}

export function ServiceCategoryMultiSelect({ categories, value, onChange }: Props) {
  const selected = useMemo(() => new Set(value), [value]);

  const toggle = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else if (next.size < MAX) next.add(id);
    onChange(Array.from(next));
  };

  const visible = categories.filter((c) => c.isActive || selected.has(c.id));

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {visible.map((c) => {
          const on = selected.has(c.id);
          return (
            <button
              type="button"
              key={c.id}
              onClick={() => toggle(c.id)}
              className="cursor-pointer outline-hidden focus-visible:ring-2 focus-visible:ring-ring rounded-md"
            >
              <Badge variant={on ? 'default' : 'outline'}>
                {c.icon ? `${c.icon} ` : ''}
                {c.name}
              </Badge>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground">
        Выбрано {selected.size}/{MAX} (минимум 1)
      </p>
    </div>
  );
}
